module.exports = "images/expert-craftmanship@2x.webp";